<script setup>
import { useI18n } from 'vue-i18n';
import LaisField from 'dashboard/components-next/LaisField.vue';

defineProps({
  errors: { type: Object, default: () => ({}) },
  form: { type: Object, required: true },
  sellers: { type: Array, default: () => [] },
  states: { type: Array, default: () => [] },
});

const emit = defineEmits([
  'setDistrictCount',
  'updateCondition',
  'updateDistrict',
]);
const { t } = useI18n();
const quantities = Array.from({ length: 10 }, (_, index) => index + 1);
</script>

<template>
  <fieldset class="grid gap-3 border-t border-lais-border-soft pt-5">
    <legend class="text-sm font-semibold text-lais-text">
      {{ t('NUCLEO_WORK_ORDERS.REQUEST.CONDITIONS.DISTRICT') }}
      {{ t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.REQUIRED_INDICATOR') }}
    </legend>
    <div class="flex gap-3">
      <button
        v-for="option in ['1', '0']"
        :key="option"
        type="button"
        class="rounded-lais border px-5 py-2 text-sm font-semibold"
        :class="
          form.vendedor_comarca === option
            ? 'border-lais-primary bg-lais-primary-50 text-lais-primary'
            : 'border-lais-border bg-white text-lais-text'
        "
        @click="emit('updateCondition', 'vendedor_comarca', option)"
      >
        {{
          option === '1'
            ? t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.YES')
            : t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.NO')
        }}
      </button>
    </div>
    <p v-if="errors.district" class="text-xs text-lais-danger">
      {{ errors.district }}
    </p>
    <template v-if="form.vendedor_comarca === '1'">
      <LaisField
        :label="t('NUCLEO_WORK_ORDERS.REQUEST.CONDITIONS.DISTRICT_QUANTITY')"
        :error="errors.district_rows"
        required
      >
        <select
          :value="form.quantidade_comarca"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @change="emit('setDistrictCount', $event.target.value)"
        >
          <option value="">
            {{ t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.SELECT') }}
          </option>
          <option
            v-for="quantity in quantities"
            :key="quantity"
            :value="quantity"
          >
            {{ quantity }}
          </option>
        </select>
      </LaisField>
      <div
        v-for="(row, index) in form.vendedores_comarca"
        :key="index"
        class="grid gap-4 rounded-lais bg-lais-bg-soft p-4 sm:grid-cols-2"
      >
        <LaisField
          :label="t('NUCLEO_WORK_ORDERS.REQUEST.CONDITIONS.SELLER')"
          :error="errors[`district_${index}`]"
          required
        >
          <select
            :value="row.vendedor"
            class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
            @change="
              emit('updateDistrict', index, 'vendedor', $event.target.value)
            "
          >
            <option value="">
              {{ t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.SELECT_SELLER') }}
            </option>
            <option
              v-for="seller in sellers"
              :key="seller.id"
              :value="seller.id"
            >
              {{ seller.name }}
            </option>
          </select>
        </LaisField>
        <LaisField
          :label="t('NUCLEO_WORK_ORDERS.REQUEST.CONDITIONS.STATE')"
          required
        >
          <select
            :value="row.estado"
            class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
            @change="
              emit('updateDistrict', index, 'estado', $event.target.value)
            "
          >
            <option value="">
              {{ t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.SELECT_STATE') }}
            </option>
            <option
              v-for="state in states"
              :key="state.value"
              :value="state.value"
            >
              {{ state.label }}
            </option>
          </select>
        </LaisField>
      </div>
    </template>
  </fieldset>
</template>
